function capitalizeFirstLetter(string: string) {
    if(string !== undefined && string !== null) {
        return string.split("_").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" ")
    }
    return string;
}

export default capitalizeFirstLetter;
